import { useSyncExternalStore } from 'react'
import { useLiveQuery } from 'dexie-react-hooks'
import { banco } from '../db/banco'
import { assinarSync, obterInfoSync, type InfoSync } from './estadoSync'

export function useSync(): InfoSync & { pendencias: number; travados: number } {
  const info = useSyncExternalStore(assinarSync, obterInfoSync)
  const total = useLiveQuery(() => banco.outbox.count(), [], 0)
  // O IndexedDB nao indexa null: so linha travada esta neste indice.
  const travados = useLiveQuery(() => banco.outbox.where('travado_em').above('').count(), [], 0)
  // Travado NAO conta como esperando -- senao o mesmo registro apareceria nos
  // dois numeros, que e a contradicao de hoje com outra roupa.
  return { ...info, pendencias: total - travados, travados }
}
